import React from "react";

export default function eyebrowUpWoman(): React.ReactElement {
  return (
    <svg
      style={{
        position: "absolute",
        width: "80%",
        height: "13%",
        top: 0
      }}
      width="149"
      height="51"
      viewBox="0 0 149 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M99 13.2143C104.667 10.5476 118 8.11427 126 19.7143" stroke="black" strokeWidth="4" strokeLinecap="round" />
      <path d="M23.5791 38.521C25.6497 32.6104 33.2612 21.3959 47.1418 23.8224" stroke="black" strokeWidth="4" strokeLinecap="round" />
      <path d="M26.0742 32.4578L19.9258 27.0312" stroke="black" strokeWidth="4" strokeLinecap="round" />
      <path d="M122.961 14.157L129.109 8.73047" stroke="black" strokeWidth="4" strokeLinecap="round" />
      <path d="M32.5233 26.8142L28.4766 19.6816" stroke="black" strokeWidth="4" strokeLinecap="round" />
      <path d="M115.512 10.5135L119.559 3.38086" stroke="black" strokeWidth="4" strokeLinecap="round" />
      <path d="M40.5994 23.2005L38.3984 15.3008" stroke="black" strokeWidth="4" strokeLinecap="round" />
      <path d="M106.436 9.89973L108.637 2" stroke="black" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}
